<div class="scrollUp" (click)="gotoTop()">
  @if (isShow) {
    <button ngClass="show">
      <img src="/icons/scroll_Up.webp" />
    </button>
  }
</div>
@if (false) {
  <a
    href="https://wa.me/523316071921?text=Hola,%20vengo%20de%20la%20p%C3%A1gina%20web"
    target="_blank"
    rel="noopener noreferrer"
    class="btnWa"
  >
    <div class="contentImage">
      <img ngSrc="/general/Whatsapp_button.svg" alt="Icono Whatsapp" fill />
    </div>
  </a>
}
